import { serializeOmnisearch, splitOmnisearch } from "components/Omnisearch/omnisearchPills";

/** Keys the occurrence panel sets itself; a parent value for these would fight the panel. */
const PANEL_OWNED_KEYS = new Set(["seriesId", "after"]);

/**
 * Search for a series' later occurrences: the list's filters (defaults merged
 * with what the user typed, user keys winning), scoped to this series and to
 * dates after the occurrence already shown on the series row.
 */
export function seriesOccurrenceSearch({
  defaultSearch,
  omnisearch,
  seriesId,
  after,
}: {
  defaultSearch: string;
  omnisearch: string;
  seriesId: string;
  after: string;
}): string {
  const parent = mergeSearch(defaultSearch, omnisearch);
  const { pairs, freeText } = splitOmnisearch(parent);
  return serializeOmnisearch(
    [
      ...pairs.filter((pair) => !PANEL_OWNED_KEYS.has(pair.key)),
      { key: "seriesId", values: [seriesId] },
      { key: "after", values: [after] },
    ],
    freeText
  );
}

/** Same merge as the task grid: a key the user set replaces that key in the default. */
function mergeSearch(defaultSearch: string, omnisearch: string): string {
  const defaults = splitOmnisearch(defaultSearch);
  const active = splitOmnisearch(omnisearch);
  const overridden = new Set(active.pairs.map((pair) => pair.key));
  const freeText = [defaults.freeText, active.freeText].filter((text) => text.length > 0).join(" ");
  return serializeOmnisearch(
    [...defaults.pairs.filter((pair) => !overridden.has(pair.key)), ...active.pairs],
    freeText
  );
}
